import { ArrowHelper, Color, Vector3 } from 'three';

import { TOOL_CONST } from '@/constant';

export const ARROW_HELPER = new ArrowHelper(
  new Vector3(1, 0, 0),
  new Vector3(0, 0, 0),
  1.5,
  0xececec,
  0.5,
  0.375,
);

export const COLOR = {
  DEFAULT_BOX: new Color(0xcdcdcd),
  get DEFAULT_LINE() {
    const box = this.DEFAULT_BOX;

    return box.toJSON();
  },
};

export const TOOL_LABELING_BOX = TOOL_CONST.TOOL_LABELING_BOX;
export const REVIEW_BOX_COLOR = '#DBDBDB';

export enum MotionType {
  NA = -1,
  Static = 0,
  Dynamic = 1,
}

export const shouldShowMotionVelocityInfo = (
  motionType: number | undefined,
): boolean => motionType === MotionType.Dynamic;

export const LAYER = {
  PIVOT_CONTROLS: 1,
};
